import { createSvgComponent } from "../../icon/createSvgComponent";
import MedicalCalendar from "@core/__generated__/icon/figma/medical-calendar.svg";
export default createSvgComponent(MedicalCalendar);